window.addEventListener( "DOMContentLoaded", function(){

  //★モックアップ用：設問リストにチェックした場合のクリックイベントを追加
  for (var i = 0; i < question_item.length; i++) {
    chqQAction(question_item[i],i);
  }

  //プレビューモーダルボタンにクリックイベントを追加
  for (var i = 0; i < btn_preview.length; i++) {
    btnPreviewAction(btn_preview[i],i);
  }

  //画像編集モーダルボタンにクリックイベントを追加
  for (var i = 0; i < btn_mod_img.length; i++) {
    btnModImgAction(btn_mod_img[i],i);
  }

});

//設問リストにチェックした場合の処理
function chqQAction(chkDOM){
  chkDOM.addEventListener("click", function(){

    var question_chk_num = 0;

    for (var i = 0; i < question_item.length; i++) {
      if(question_item[i].checked) {
        question_chk_num++;
      }
    }

    if(question_chk_num > 0) {
      //右カラムに表示
      showAllSelectedQuestion();
    }else{
      //右カラムを非表示
      delAllSelectedQuestion();
    }

  });
}


//プレビューモーダルを表示する
//プレビューモーダルの「箱」は１つのみ。その箱の中の各要素に、jsonで取得した情報を格納して、モーダルを開く処理を実装する想定
function showPreviewModal() {
  
  preview_modal.style.visibility = "visible";
  preview_modal.style.opacity = 1;
}

//プレビューボタンクリック時に、プレビューモーダルを表示する。
function btnPreviewAction(btnDOM,btnId){
  btnDOM.addEventListener("click", function(){
    //とりあえず画像のみ、親要素のlabelタグのdatasetに設定した画像パスから取得。
    preview_modal_img.innerHTML = '<img src="'+btnDOM.closest('label').dataset.img+'">';

    //下記はベタ代入だが、同じように単元や難易度などもdatasetやjsonから直接代入してやると良い
    preview_tangen.innerHTML = '仕事とエネルギー';
    preview_difficulty.innerHTML = '基本';
    preview_keisai.innerHTML = '東京書籍';
    preview_cnt.innerHTML = '9';

    showPreviewModal();
  });
}

//画像編集モーダルを表示する
//画像編集モーダルの「箱」は１つのみ。その箱の中の各要素に、jsonで取得した情報を格納して、モーダルを開く処理を実装する想定
function showModImgModal() {
  
  mod_img_modal.style.visibility = "visible";
  mod_img_modal.style.opacity = 1;
}

//プレビューボタンクリック時に、プレビューモーダルを表示する。
function btnModImgAction(btnDOM,btnId){
  btnDOM.addEventListener("click", function(){
    showModImgModal();
  });
}